export default "__VITE_ASSET__2d0fe1bf__"